import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { EventInitVariables } from '../email-template/event.interface';

export interface PushModel extends BaseModel {
  variables?: { [key: string]: string } | PushVariables;
}

export interface PushVariables {
  PushCopy: string;
  PushLink: string;
  PushSubject: string;
  PushTitle: string;
}

export class PushInitVariables implements PushVariables {
  PushCopy = '';
  PushLink = '';
  PushSubject = '';
  PushTitle = '';
}

export class PushInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PushInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
